/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilieraCreateDTO
 */
export interface FilieraCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof FilieraCreateDTO
     */
    descrizione: string;
    /**
     * 
     * @type {number}
     * @memberof FilieraCreateDTO
     */
    idAnagrafe?: number;
}

/**
 * Check if a given object implements the FilieraCreateDTO interface.
 */
export function instanceOfFilieraCreateDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "descrizione" in value;

    return isInstance;
}

export function FilieraCreateDTOFromJSON(json: any): FilieraCreateDTO {
    return FilieraCreateDTOFromJSONTyped(json, false);
}

export function FilieraCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilieraCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'descrizione': json['descrizione'],
        'idAnagrafe': !exists(json, 'idAnagrafe') ? undefined : json['idAnagrafe'],
    };
}

export function FilieraCreateDTOToJSON(value?: FilieraCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'descrizione': value.descrizione,
        'idAnagrafe': value.idAnagrafe,
    };
}

